import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationModalService } from "@app/admin/confirmation-modal.service";
import {
  RequestState,
  RequestStateEnum,
} from "@app-module/shared/RequestState";
import { PopupLayoutComponent } from "@app/admin/confirmation-popup/popup-layout/popup-layout.component";
import { Subscription } from "rxjs";
import { UserService } from "@app-service/user.service";
import { DashboardCardsService } from "@app-service/dashboard-cards.service";
import { ToasterService, ToasterType } from "@app-service/toaster.service";
import { GenericContactDetailsComponent } from "../generic-contact-details/generic-contact-details.component";
import { PCGenericContactDetailsComponent } from "./generic-contact-details/pc-generic-contact-details.component";
import { CreatePettyCashAccountPopupComponent } from "./create-petty-cash-account-popup/create-petty-cash-account-popup.component";
import {
  ENKASH_TENANT_VALUE,
  tenantSetter,
} from "@app-common/http/interceptors/tenantType";
@Component({
    selector: "app-petty-cash-popup",
    templateUrl: "./petty-cash-popup.component.html",
    styleUrls: ["./petty-cash-popup.component.scss"],
    standalone: false
})
export class PettyCashPopupComponent implements OnInit {
  constructor(
    public userService: UserService,
    private cardsDashboardService: DashboardCardsService,
    private toasterService: ToasterService,
    private confirmationModal: ConfirmationModalService
  ) {
    this.submitRequestState = RequestState.init();
  }

  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }
  private subscriptions: Subscription = new Subscription();
  submitRequestState: RequestState;
  @ViewChild("modal") modal: PopupLayoutComponent;

  ngOnInit(): void {}

  onSetup(): void {
    this.confirmationModal.showInformationalModal(
      CreatePettyCashAccountPopupComponent,
      {
        centered: true,
        scrollable: true,
        size: "xl",
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  onRequestDemo(): void {
    tenantSetter(ENKASH_TENANT_VALUE);
    this.submitRequestState.pending();
    this.subscriptions.add(
      this.cardsDashboardService
        .captureInterest("PETTY_CASH_DEMO_REQUEST")
        .subscribe(
          (res) => {
            this.modal.close();
            this.submitRequestState.completed();
            this.confirmationModal.showInformationalModal(
              PCGenericContactDetailsComponent,
              {
                centered: true,
                scrollable: true,
                size: "sm",
              }
            );
          },
          (err) => {
            this.submitRequestState.rejected();
            this.toasterService.showToaster(
              err["error"]["payload"]
                ? err["error"]["payload"]
                : "Something went wrong",
              ToasterType.ERROR
            );
          }
        )
    );
  }
}
